import { useState } from 'react'
import { Card, CardBody, Col, Toast, ToastBody, ToastHeader } from 'reactstrap';
import { DefaultToasts } from '../../../../Utils/Constants';
import { Btn, Image } from '../../../../AbstractElements';
import { defaultToastData } from '../../../../Data/BonusUi/Toast/Toast';
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon';
import { dynamicImage } from '../../../../Utils';

const DefaultToast = () => {
    const [open, setOpen] = useState(true);

    return (
      <Col md="6">
        <Card className="height-equal">
          <CardHeaderCommon title={DefaultToasts} span={defaultToastData} />
          <CardBody className="toast-rtl">
            <Toast className="default-show-toast" isOpen={open}>
              <ToastHeader className="toast-img stacking-toast">
                <Image className="rounded me-2" src={dynamicImage(`other-images/profile.png`)} alt="profile" />
                <div>Lagos theme</div>
                <small className="d-sm-block d-none m-auto">10 min ago</small>
                <Btn close className="p-0" onClick={() => setOpen(false)}></Btn>
              </ToastHeader>
              <ToastBody className="toast-dark">
                <strong className="txt-success">Well done!</strong> You successfully read this important message.
              </ToastBody>
            </Toast>
          </CardBody>
        </Card>
      </Col>
    );
}

export default DefaultToast